import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type ThreatDefenceSetting } from "features/Accounts/types";
import { getPrefix } from "features/Application/slices/models";
import { type AccountDomain } from "../../../../../Library/SimulatedPhishing/Domains/types/state";

export interface ThreatDefenceSettingsState {
  settings: ThreatDefenceSetting;
  accountDomain?: AccountDomain;
  isLoading: boolean;
  error: Error | undefined;
}

const initialState: ThreatDefenceSettingsState = {
  settings: {
    hasMsGraphSettings: false,
  },
  accountDomain: undefined,
  isLoading: false,
  error: undefined,
};

export const editThreatDefenceSettingsSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.ThreatDefenceSettings,
    name: "edit",
  }),
  initialState,
  reducers: {
    req(state: ThreatDefenceSettingsState) {
      state.isLoading = true;
    },
    got(
      state: ThreatDefenceSettingsState,
      action: PayloadAction<{ settings: ThreatDefenceSetting; accountDomain?: AccountDomain }>,
    ) {
      state.isLoading = false;
      state.settings = action.payload.settings;
      state.accountDomain = action.payload.accountDomain;
    },
    err(state: ThreatDefenceSettingsState, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { req, got, err } = editThreatDefenceSettingsSlice.actions;

export default editThreatDefenceSettingsSlice.reducer;
